import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SubjectsContext = createContext();

export const useSubjects = () => useContext(SubjectsContext);

export const SubjectsProvider = ({ children }) => {
  const [subjects, setSubjects] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = import.meta.env.VITE_APP_BASE_URL;

  // Always fetch if subjects is null (including after error)
  useEffect(() => {
    if (subjects === null) {
      setLoading(true);
      setError(null);
      axios
        .get(`${baseUrl}/api/subjects`)
        .then((res) => setSubjects(res.data))
        .catch((err) => setError(err))
        .finally(() => setLoading(false));
    }
  }, [subjects, baseUrl]);

  // Expose a manual refetch function for retry (optional)
  const refetchSubjects = () => setSubjects(null);
  const resetSubjectsState = () => {
    setSubjects(null);
    setLoading(true);
    setError(null);
  };

  return (
    <SubjectsContext.Provider
      value={{ subjects, loading, error, refetchSubjects, resetSubjectsState }}
    >
      {children}
    </SubjectsContext.Provider>
  );
};
